export default __webpack_public_path__ + "static/media/NoeDisplay-Medium.c2540771.otf";